import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { WorkplaceAddressDTO } from '../types/workplace-address';
import { WorkplaceApiObject } from '../types/workplace-response';

@Injectable({
  providedIn: 'root',
})
export class WorkplaceAddressHttpService {
  private http = inject(HttpClient);

  public update$(
    companyID: number,
    workplaceID: number,
    payload: WorkplaceAddressDTO
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/workplaces/${workplaceID}/addresses`;

    return this.http.patch<WorkplaceApiObject>(url, payload);
  }
}
